module.exports = __webpack_public_path__ + "img/toilet-paper-under.23407e6a.svg";